import React from "react";
import { connect } from "react-redux";
import { createDeal } from "actions/deal";
import { closeDealModal } from "actions/deal_modal";
import DealForm from "forms/DealForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

const { t } = new Translate("DealModal");

const DealModal = ({ isLoading, onClose, onSave, parent }) => {
  const handleClose = () => {
    if (!isLoading && confirm(t("confirm.cancel"))) onClose(); // eslint-disable-line
  };

  return (
    <Modal onClose={handleClose} isOpen>
      <ModalHeader onClose={handleClose}>{t("header")}</ModalHeader>
      <ModalBody>
        <DealForm onSubmit={onSave} parent={parent} />
      </ModalBody>
    </Modal>
  );
};

DealModal.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  parent: PropTypes.oneOf(["Asset", "Portfolio"]),
};

const mapStateToProps = ({ dealModal: { parent }, loading }) => ({
  parent,
  isLoading: loading.deal || loading.tenant || loading.post,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closeDealModal()),
  onSave: (deal) =>
    dispatch(createDeal(deal, deal.portfolio, deal.assets)).then(() => dispatch(closeDealModal())),
});

export default connect(mapStateToProps, mapDispatchToProps)(DealModal);
